import React, { useState } from 'react';
import ReceberAportes from './ReceberAportes';
import AportesProgramados from './AportesProgramados';
import './AportesHub.css';

/**
 * AportesHub.js — casca com abas do módulo de Aportes (Stark Bank Banking).
 * ---------------------------------------------------------------------------
 * Segura duas telas irmãs sem tocar em nenhuma delas:
 *   • Receber Aportes    → chave Pix, cobrança avulsa, boleto, recebimentos
 *   • Aportes Programados → cobranças recorrentes geradas e enviadas sozinhas
 *
 * Aponte aqui o que hoje renderiza <ReceberAportes />. Cada tela mantém a
 * própria hidratação de ambiente (GET /account), então a troca de aba é só
 * visual — nada some nem vaza entre ambientes.
 */

const ABAS = [
    { id: 'receber', label: 'Receber Aportes' },
    { id: 'programados', label: 'Aportes Programados' },
];

export default function AportesHub() {
    const [aba, setAba] = useState('receber');

    return (
        <div className="aph-shell">
            <div className="aph-tabbar">
                <div className="aph-tabs" role="tablist" aria-label="Aportes">
                    {ABAS.map((t) => (
                        <button
                            key={t.id}
                            role="tab"
                            aria-selected={aba === t.id}
                            className={`aph-tab ${aba === t.id ? 'active' : ''}`}
                            onClick={() => setAba(t.id)}
                        >
                            {t.label}
                        </button>
                    ))}
                </div>
            </div>

            <div className="aph-body">
                {aba === 'receber' ? <ReceberAportes /> : <AportesProgramados />}
            </div>
        </div>
    );
}